// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"8791a731","766":"556da8d4"}[chunkId] + ".chunk.js";
};